import { Box } from '@mui/material'
import FilterDropdown from '../Forms/FilterDropdown/FilterDropdown'
import { CommonPrivacy } from 'features/common/types'
import { SharedOptionDescription } from './ShareOptionShared/ShareOptionShared'
import { ReactNode, useMemo } from 'react'
import { PrivatePrivacy, PublicPrivacy, SharedPrivacy } from './SharingOptions'
import { Typography } from '@carto/meridian-ds/components'
import { ContextMenuItem } from '../ContextMenu'
import PrivacyIcon from './PrivacyIcon'

export const PrivacySettingsRadioGroup = ({
  value = CommonPrivacy.Shared,
  options = [PrivatePrivacy, SharedPrivacy, PublicPrivacy],
  description: customDescription,
  onChange,
  disabled
}: {
  value: CommonPrivacy
  onChange: (item: ContextMenuItem) => void
  description?: ReactNode
  options?
  disabled?: boolean
}) => {
  const selectedOption = useMemo(() => options.find((po) => po.id === value), [value, options])

  const description = useMemo(() => {
    if (customDescription) {
      return customDescription
    } else if (value === CommonPrivacy.Shared) {
      return <SharedOptionDescription />
    } else {
      return selectedOption?.description
    }
  }, [customDescription, value, selectedOption])

  return (
    <Box display="flex" alignItems="center">
      <PrivacyIcon privacy={value} size="medium" />
      {disabled ? (
        <Typography px={2} variant="body1" weight="medium">
          {selectedOption.label}
        </Typography>
      ) : (
        <FilterDropdown
          aria-label="select-sharing-mode"
          value={selectedOption}
          menuItems={options}
          buttonSize="large"
          placement="bottom-start"
          onClickItem={onChange}
          disabled={disabled}
        />
      )}
      <Box overflow="hidden">
        <Typography ml={0.5} variant="body2" color="textSecondary" component="div">
          {description}
        </Typography>
      </Box>
    </Box>
  )
}

export default PrivacySettingsRadioGroup
